module.exports = __webpack_public_path__ + "static/media/absIcon.7eea0c4a.svg";